<mat-dialog-content class="mat-dialog-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Select Language String</h4>
    <i class="fas fa-times pull-right fontL3 pointer" (click)="cancel()"></i>
  </div>
  <div class="modal-body mt-3">
    <div class="col-xs-12 p-0 mb-3 flex">
      <div class="col-xs-8">
        <input class="w100 custom-select-ticket" [formControl]="searchControl" placeholder="Type here to search"/>
      </div>
      <div class="col-xs-4 pl-3">
        <button type="button" class="btn-primary" [disabled]="!searchControl.value" (click)="addLanguageString()">Add</button>
      </div>
    </div>
    <div class="col-xs-12 flex p-0">
      <div class="col-xs-12">
        <select class="w100 custom-select-ticket" [(ngModel)]="selectedValue" (ngModelChange)="onSelectionChange()" [ngClass]="{ 'bg-light': !selectedValue}">
          <option [value]="''" disabled="disabled" selected="selected">Select a language string</option>
          <option *ngFor="let option of options;" [value]="option.value">{{option.display}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn-primary-outline pull-right ml-2" (click)="cancel()">Cancel</button>
    <button class="btn-primary pull-right" (click)="save()">Save</button>
  </div>
</mat-dialog-content>

